import { gql } from '@apollo/client'

// `anonymous_product_tag_ids` is a plain scalar `Int[]` column (no join
// table, no FK). `TagsSelect` only needs the raw ids and loads tag labels
// itself via `GET_TAGS_FOR_SELECT`.
export const GET_PRODUCT_SETTINGS = gql`
  query GET_PRODUCT_SETTINGS {
    findFirstShopSetting {
      id
      anonymous_product_tag_ids
    }
  }
`

// Uses the dedicated hand-written `updateShopSettingsV2` mutation (same one
// `LanguageSettings` calls — see `languageSettingsQueries.ts`) instead of the
// generated `updateOneShopSetting`. Two things the resolver requires:
// - `shopSettingsId` is typed as nullable but is effectively required: the
//   resolver only applies the update when it's truthy, so omitting it is a
//   silent no-op. Always pass the loaded `findFirstShopSetting.id`.
// - `anonymous_product_tag_ids` must always be sent as a bare `number[]`
//   (full-replace semantics, `[]` clears it) — omitting the variable leaves
//   the column untouched, so never drop the key even when the selection is
//   empty.
export const UPDATE_PRODUCT_SETTINGS = gql`
  mutation UPDATE_PRODUCT_SETTINGS(
    $shopSettingsId: Int
    $anonymous_product_tag_ids: [Int]
  ) {
    updateShopSettingsV2(
      shopSettingsId: $shopSettingsId
      anonymous_product_tag_ids: $anonymous_product_tag_ids
    ) {
      id
      anonymous_product_tag_ids
    }
  }
`

// Admin-only catalogue sweep -- see
// `furnisystems-backend/src/types-modified/SofaFormBlueprint.ts`
// (renderAllMissingBlueprintsMutation). Takes no arguments: it walks every
// enabled module, hashes its geometry, and enqueues a render for every hash
// that isn't already `rendered`. Returns as soon as the sweep has queued the
// jobs -- it does NOT wait for BullMQ to actually render them (that can take
// 15-30 minutes on the real catalogue), so there is nothing here to poll.
//
// Throws (as a plain GraphQLError, no partial data) if
// BLUEPRINT_RENDER_ENABLED is off on the backend -- that message names the
// flag explicitly and must be shown to the admin verbatim, not swallowed.
export const RENDER_ALL_MISSING_BLUEPRINTS = gql`
  mutation RenderAllMissingBlueprints {
    renderAllMissingBlueprints {
      total_modules
      unique_hashes
      already_rendered
      enqueued
    }
  }
`
